/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import { IXM_EVENTS_V1_POLL_SERVICE_RECEIVE_AUDIENCE, ixmEventsV1PollServiceReceive } from '@interxfi/api-client/generated/client-functions/ixm-events-v1-poll-service-receive';
import type { IxmEventsV1PollServiceReceiveReceiveRequest, IxmEventsV1PollServiceReceiveResponse, IxmUserauthV1JoinedRealmAccess, IxmUserauthV1RealmState } from '@interxfi/types';
import { type DefinedInitialDataOptions, queryOptions, useQuery } from '@tanstack/react-query';
import { withAuthorizationToken } from '../../api-client';
import { useRealmAuthActiveAccess, useRealmAuthIsAuthenticated } from '../../context';
import { type TenantContext, useRealmAPIContext } from '../../realm-context';

/**
 * @generated by NormalizedQueryPlugin (get /events/v1/receive) */

export function buildIxmEventsV1PollServiceReceiveKey(request?: IxmEventsV1PollServiceReceiveReceiveRequest) { return ['ixmEventsV1PollServiceReceive', 'detail', request] as const; }

export function buildIxmEventsV1PollServiceReceiveQueryOptions(baseUrl: string | undefined, isAuthenticated: boolean, token: string | undefined, realm: IxmUserauthV1RealmState | undefined, tenantContext: TenantContext | undefined, extendKey: any, request?: IxmEventsV1PollServiceReceiveReceiveRequest | undefined, options?: Partial<DefinedInitialDataOptions<IxmEventsV1PollServiceReceiveResponse | undefined>>) { return queryOptions({
    queryKey: extendKey(buildIxmEventsV1PollServiceReceiveKey(request)),
    queryFn: async () => ixmEventsV1PollServiceReceive(baseUrl, request, withAuthorizationToken(token)),
    enabled: Boolean(isAuthenticated && token && realm && request && tenantContext && IXM_EVENTS_V1_POLL_SERVICE_RECEIVE_AUDIENCE.includes(tenantContext)),
    ...options
}); }

export function useIxmEventsV1PollServiceReceive(request?: IxmEventsV1PollServiceReceiveReceiveRequest | undefined, options?: Partial<DefinedInitialDataOptions<IxmEventsV1PollServiceReceiveResponse | undefined>>, withAccess?: IxmUserauthV1JoinedRealmAccess) {
    const isAuthenticated = useRealmAuthIsAuthenticated();
    const activeAccess = useRealmAuthActiveAccess();
    const { realm, baseUrl, extendKey, token, tenantContext } = useRealmAPIContext(withAccess ?? activeAccess);
    
    return useQuery(buildIxmEventsV1PollServiceReceiveQueryOptions(baseUrl, isAuthenticated, token, realm, tenantContext, extendKey, request, options));
}
